<script>
import { TheMask } from 'vue-the-mask';
export default {
    name: 'TwInputText',
    props: ['errors', 'type', 'name', 'value', 'placeholder', 'label', 'rules', 'class_names', 'updateFieldsForm', 'masksD', 'var', 'autocomplete', 'select_values', 'forceValidation', 'maxlenght', 'masked'],
    components: { TheMask },
    watch: {
        value: {
            handler(e) {
                this.field_value = e;
            },
            immediate: true
        },
        field_value: {
            handler(e) {
                this.processData(e);
                this.force_validation_style = false;
                if (e !== '') {
                    this.isMounted = true;
                }
            },
            immediate: true
        },
        forceValidation: {
            handler(e) {
                if (e !== false) {
                    this.validateStyle();
                }
            }
        },
        isMounted: {
            handler(e) {
                if (e === true) {
                    this.$nextTick(() => {
                        this.processData(this.field_value, 'isMounted');
                    })
                }
            },
            immediate: true
        },
        isFocused: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                }
            }
        },
        isEnter: {
            handler(e) {
                if (e !== false) {
                    this.validateStyle();
                    this.processData(this.field_value, 'isEnter');
                }
            }
        },
        isClick: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                }
            }
        },
        isBlur: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                }
            }
        },
        isChange: {
            handler(e) {
                if (e === true) {
                    this.validateStyle();
                    this.processData(this.field_value, 'isChange');
                }
            }
        },
        observeFocusOut: {
            handler(e) {
                if (e !== false) {
                    this.processData(this.field_value, 'isFocusOut');
                }

                this.isFocused = false;
                this.isEnter = false;
                this.isClick = false;
                this.isFocusOut = false;
                this.isBlur = false;
                this.isChange = false;
                this.isClickSubmitButton = false;
                this.isInputSubmit = false;


                this.force_validation_style = false;
            }
        },
        clickSubmitButton: {
            handler(e) {
                if (e === true) {
                    this.isClickSubmitButton = true;
                } else {
                    this.isClickSubmitButton = false;
                }
            }
        },
        inputSubmit: {
            handler(e) {
                if (e === true) {
                    this.isInputSubmit = true;
                } else {
                    this.isInputSubmit = false;
                }
            }
        }
    },
    computed: {
        observeFocusOut() {
            return this.isFocusOut;
        },
        clickSubmitButton() {
            return this.$store.getters['getFormState'].clickSubmitButton;
        },
        inputSubmit() {
            return this.$store.getters['getFormState'].inputSubmit;
        }
    },
    methods: {
        required() {
            if (this.field_value == "") {
                this.msg_error = this.errors;
                return false;
            } else {
                this.msg_error = "";
                return true;
            }
        },
        minlenght() {
            if (this.field_value && (parseInt(this.field_value.length) < parseInt(this.rules.minlenght))) {
                this.msg_error = "Verifique este campo";
                return false;
            } else {
                this.msg_error = "";
                return true;
            }
        },
        email() {
            try {
                let emailzero = this.field_value.toLowerCase();
                let email = emailzero.replace(/\s+/g, '');

                this.field_value = email;

                if (!/[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z\s]{2,5}$/.test(email)) {
                    this.msg_error = "E-mail inválido";
                    return false;
                } else {
                    this.msg_error = "";
                    return true;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate Email`, message: `${error}` })
                });
            }

        },
        phone_number() {
            try {
                let phone_numberzero = this.field_value;
                let phone_number = phone_numberzero.replace(/\s+/g, '');

                if (/^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$/.test(phone_number)) {
                    this.msg_error = "";
                    return true;
                } else if (/^(00|)[1-9]{1}([0-9][\s]*){9,16}$/.test(phone_number)) {
                    this.msg_error = "";
                    return true;
                } else if (/^(00|\+)[1-9]{1}([0-9][\s]*){9,16}$/.test(phone_number)) {
                    this.msg_error = "";
                    return true;
                } else {
                    this.msg_error = "Telefone informado é inválido";
                    return false;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate phone_number`, message: `${error}` })
                });
            }
        },
        document() {
            try {
                let cpf = this.field_value;
                if (cpf) {
                    cpf = cpf.replace(/\D/g, '')
                    if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) {
                        this.msg_error = "CPF inválido"
                        return false
                    }
                    var result = true
                        ;[9, 10].forEach(function (j) {
                            var soma = 0,
                                r
                            cpf.split(/(?=)/)
                                .splice(0, j)
                                .forEach(function (e, i) {
                                    soma += parseInt(e) * (j + 2 - (i + 1))
                                })
                            r = soma % 11
                            r = r < 2 ? 0 : 11 - r
                            if (r != cpf.substring(j, j + 1)) result = false
                        })

                    if (result === true) {
                        this.msg_error = "";
                    } else {
                        this.msg_error = "CPF inválido"
                    }

                    return result
                } else {
                    this.msg_error = "CPF inválido"
                    return false
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate document`, message: `${error}` })
                });
            }
        },
        documentCnpj() {
            try {
                let cnpj = this.field_value;
                if (cnpj) {
                    cnpj = cnpj.replace(/\D/g, '');
                    if (cnpj.length != 14) {
                        this.msg_error = "CNPJ inválido";
                        return false;
                    }

                    if (/^(\d)\1+$/.test(cnpj)) {
                        this.msg_error = "CNPJ inválido";
                        return false;
                    }

                    var tamanho = cnpj.length - 2
                    var numeros = cnpj.substring(0, tamanho);
                    var digitos = cnpj.substring(tamanho);
                    var soma = 0;
                    var pos = tamanho - 7;
                    for (i = tamanho; i >= 1; i--) {
                        soma += numeros.charAt(tamanho - i) * pos--;
                        if (pos < 2)
                            pos = 9;
                    }
                    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                    if (resultado != digitos.charAt(0)) {
                        this.msg_error = "CNPJ inválido";
                        return false;
                    }

                    tamanho = tamanho + 1;
                    numeros = cnpj.substring(0, tamanho);
                    soma = 0;
                    pos = tamanho - 7;
                    for (i = tamanho; i >= 1; i--) {
                        soma += numeros.charAt(tamanho - i) * pos--;
                        if (pos < 2)
                            pos = 9;
                    }
                    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                    if (resultado != digitos.charAt(1)) {
                        this.msg_error = "CNPJ inválido";
                        return false;
                    }

                    this.msg_error = "";
                    return true;
                } else {
                    this.msg_error = "CNPJ inválido";
                    return false;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate documentCnpj`, message: `${error}` })
                });
            }
        },
        zip_code() {
            try {
                let zip_code = this.field_value.replace(/^(\+)|\D/g, "$1").trim();

                if (!/\d{5}-?\d{3}/.test(zip_code)) {
                    this.msg_error = "CEP inválido";
                    return false;
                } else {
                    this.msg_error = "";
                    return true;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate zip_code`, message: `${error}` })
                });
            }
        },
        expirationDate() {
            try {
                var value = this.field_value;

                var today = new Date();
                var startDate = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);
                var expDate = value.replace(/\s/g, "");
                var separatorIndex = expDate.indexOf('/');
                expDate = expDate.substr(0, separatorIndex) + '/1' + expDate.substr(separatorIndex);
                if (Date.parse(startDate) <= Date.parse(expDate)) {
                    this.msg_error = "";
                    return true;
                } else {
                    this.msg_error = 'Expiração do Cartão Incorreta';
                    return false;
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate expirationDate`, message: `${error}` })
                });
            }
        },
        validateCreditcard() {
            try {
                a = this.field_value.replace(/\s+/g, '');
                if (/[^0-9 \-]+/.test(a)) return !1;
                var c, d, e = 0,
                    f = 0,
                    g = !1;
                if (a = a.replace(/\D/g, ""), a.length < 13 || a.length > 19) return !1;
                for (c = a.length - 1; c >= 0; c--) d = a.charAt(c), f = parseInt(d, 10), g && (f *= 2) > 9 && (f -= 9), e += f, g = !g;
                return e % 10 === 0
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate expirationDate`, message: `${error}` })
                });
            }
        },
        validateCardNumber() {
            try {
                // Remover espaços em branco
                var cardNumber = this.field_value.replace(/\s/g, '');

                // Verificar se o número tem 16 dígitos
                if (cardNumber.length !== 16) {
                    this.msg_error = 'Número de cartão inválido';
                    return false;
                }

                // Verificar se o número é válido usando o algoritmo de Luhn
                let sum = 0;
                for (let i = 0; i < cardNumber.length; i++) {
                    let digit = parseInt(cardNumber.charAt(i));
                    if (i % 2 === 0) {
                        digit *= 2;
                        if (digit > 9) {
                            digit = (digit % 10) + 1;
                        }
                    }
                    sum += digit;
                }

                // Verificar se o número é válido
                if (sum % 10 !== 0) {
                    this.msg_error = 'Número de cartão inválido';
                    return false;
                }

                this.msg_error = 'Número de cartão válido';
                return true;
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate validateCardNumber`, message: `${error}` })
                });
            }
        },
        checkValid() {
            try {
                if (typeof this.field_value !== 'undefined') {
                    if (this.rules) {
                        let checkValidResult = false;

                        if (this.rules.required) {
                            checkValidResult = this.required();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.email) {
                            checkValidResult = this.email();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.minlenght) {
                            checkValidResult = this.minlenght();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.phone_number) {
                            checkValidResult = this.phone_number();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.document) {
                            checkValidResult = this.document();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.documentCnpj) {
                            checkValidResult = this.documentCnpj();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.zip_code) {
                            checkValidResult = this.zip_code();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.expiration_date) {
                            checkValidResult = this.expirationDate();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                        if (this.rules.validateCardNumber) {
                            checkValidResult = this.validateCardNumber();
                            this.valid = checkValidResult;
                            if (!checkValidResult) {
                                return false;
                            }
                        }

                    } else {
                        this.valid = true;
                    }
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate checkValid`, message: `${error}` })
                });
            }
        },
        updateField(e, event) {
            try {
                this.field_value = e;
                if (typeof e !== 'undefined') {

                    this.$emit('updateFieldsForm', {
                        valid: this.valid,
                        field: this.name,
                        var: this.var,
                        value: this.field_value,
                        event: event,
                        eventsModel: {
                            isFocused: this.isFocused,
                            isClick: this.isClick,
                            isBlur: this.isBlur,
                            isChange: this.isChange,
                            isEnter: this.isEnter,
                            isFocusOut: this.isFocusOut,
                            isClickSubmitButton: this.isClickSubmitButton,
                            isInputSubmitAction: this.isInputSubmit
                        }
                    });

                } else {

                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate updateField`, message: `${error}` })
                });
            }
        },
        validateStyle() {
            try {
                if (this.rules) {

                    if (this.valid === true) {
                        this.force_validation_style = false;

                        if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                            console.log("Action: 0 - Input", this.name, {
                                isFocused: this.isFocused,
                                isClick: this.isClick,
                                isBlur: this.isBlur,
                                isEnter: this.isEnter,
                                isFocusOut: this.isFocusOut,
                                isClickSubmitButton: this.isClickSubmitButton,
                                isInputSubmitAction: this.isInputSubmit,
                                isValid: this.valid
                            });

                        }

                    } else {
                        this.$nextTick(() => {

                            if (this.isFocused === true && (this.isClickSubmitButton === true || this.isInputSubmit === true || this.value !== '')) { // FOCUS SEM CLIQUE NO INPUT
                                this.force_validation_style = true;

                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    console.log("Action: 1 - Input", this.name, {
                                        isFocused: this.isFocused,
                                        isClick: this.isClick,
                                        isBlur: this.isBlur,
                                        isEnter: this.isEnter,
                                        isFocusOut: this.isFocusOut,
                                        isClickSubmitButton: this.isClickSubmitButton,
                                        isInputSubmitAction: this.isInputSubmit
                                    });
                                }

                            } else if (this.isEnter === true) { // PRESSIONOU ENTER DENTRO DO INPUT
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    console.log("Action: 2 - Input", this.name);
                                }
                                this.isEnter = false;
                            } else if (this.isClickSubmitButton === true) { // CLICK BUTTON SUBMIT
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    console.log("Action: 7 - Input", this.name);
                                }
                                this.isClickSubmitButton = false;
                            } else if (this.isFocused === true && this.field_value !== '' && this.isClickSubmitButton === true) { // FOCUS SEM CLIQUE NO INPUT
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    console.log("Action: 3 - Input", this.name);
                                }
                                this.isFocused = false;
                                this.isClickSubmitButton = false;
                            } else if (this.isBlur === true && this.value != "") { // PRESSIONOU ENTER DENTRO DO INPUT
                                this.force_validation_style = true;
                                this.isBlur = false;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    console.log("Action: 4 - Input", this.name);
                                }
                            } else if (this.forceValidation === true) {
                                this.force_validation_style = true;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    console.log("Action: 5 - Input", this.name);
                                }
                            } else {
                                this.force_validation_style = false;
                                if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
                                    console.log("Action: 6 - Input", this.name);
                                }
                            }
                        })

                    }
                }
            } catch (error) {
                fetch(`https://api.unicopag.com.br/api/api/notifications/errors`, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ title: `Validate validateStyle`, message: `${error}` })
                });
            }

            // console.log("Input:"+this.name, this.rules, "Valid?"+this.valid, "Focused?"+this.isFocused, "isEnter?"+this.isEnter, "ForceValidation?"+this.force_validation_style, "ERROR:"+this.msg_error)
        },
        // processData(e, event = null) {
        //     this.checkValid();
        //     this.$nextTick(() => {
        //         this.updateField(e, event);
        //     });
        // },
        processData(e, event = null) {
            this.checkValid();
            this.$nextTick(() => {
                this.updateField(e, event);
            });
        }
    },
    data() {
        return {
            msg_error: "",
            field_value: "",
            valid: false,
            force_validation_style: false,
            isMounted: false,
            isFocused: false,
            isClick: false,
            isBlur: false,
            isEnter: false,
            isFocusOut: false,
            isClickSubmitButton: false,
            isChange: false,
            isInputSubmit: false,
            timeout: null,
        }
    }
}
</script>
<template>
    <div :class="class_names">
        <div v-if="type !== 'select'"
            class="relative rounded-md border-2 border-gray-300 px-2 py-2 my-3 sm:mx-1 shadow-inner focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-300"
            :class="{ 'border-red-500  ring-red-300 focus-within:ring-red-300 focus-within:border-red-500': (force_validation_style === true) }">
            <label v-if="(force_validation_style === false)" :for="name"
                class="absolute overflow-hidden -top-2 left-2 -mt-px inline-block bg-white px-1 text-sm text-gray-800 font-bold">{{
                    label }}</label>
            <label v-else
                class="absolute -top-2 left-2 -mt-px inline-block bg-white overflow-hidden px-1 text-sm font-medium text-red-600"
                id="email-error">{{ msg_error }}</label>
            <!--  @blur.native="validateStyle()" -->
            <TheMask v-if="masksD" :mask="masksD" :masked="masked" @blur.native="isBlur = true"
                @change.native="isChange = true" @focusout.native="isFocusOut = true" @focus.native="isFocused = true"
                @click.native="(isClick = true);" @keypress.enter.native="isEnter = true;" v-model.trim="field_value"
                :value="value" :ref="name" :type="type" :name="name" :id="name" :maxlenght="maxlenght"
                class="block w-full py-1 p-0 text-gray-900 placeholder-gray-500 focus:ring-0 border-0 sm:text-sm"
                :class="{ 'placeholder-red-200': (force_validation_style === true) }" :autocomplete="autocomplete"
                :inputmode="type" autocapitalize="off" autocorrect="off" spellcheck="false"
                :placeholder="(value == '') ? placeholder : ''" />

            <input v-else @blur="isBlur = true" @keypress.enter="isEnter = true;" @change="isChange = true"
                @focusout="isFocusOut = true" @focus="(isFocused = true)" @click="(isClick = true);"
                v-model.trim="field_value" :value="value" :ref="name" :type="type" :name="name" :id="name"
                :maxlenght="maxlenght"
                class="block w-full py-1 p-0 text-gray-900 placeholder-gray-500 border-0 focus:ring-0 sm:text-sm"
                :class="{ 'placeholder-red-200': (force_validation_style === true) }" :autocomplete="autocomplete"
                :inputmode="type" autocapitalize="off" autocorrect="off" spellcheck="false"
                :placeholder="(value == '') ? placeholder : ''" />

            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
                v-if="(force_validation_style === true)">
                <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                    aria-hidden="true">
                    <path fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
                        clip-rule="evenodd" />
                </svg>
            </div>
        </div>

        <div v-if="type == 'select'"
            class="relative rounded-md border-2 border-gray-300 shadow-inner my-3 sm:mx-1 px-1 focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-300"
            :class="{ 'border-red-500  ring-red-300 focus-within:ring-red-300 focus-within:border-red-500': (force_validation_style === true) }">
            <label :for="name"
                class="absolute overflow-hidden -top-2 left-2 -mt-px inline-block bg-white px-1 text-xs font-medium text-gray-900">{{
                    label }}</label>

            <select @blur="isBlur = true;" @keypress.enter="isEnter = true;" @change="isChange = true" v-model="field_value"
                :value="value" :ref="name" :type="type" :name="name" :id="name"
                class="block w-full text-gray-900 border-0 focus:ring-0 sm:text-sm"
                :class="{ 'placeholder-red-200': (force_validation_style === true) }" :autocomplete="autocomplete"
                :inputmode="type" autocapitalize="off" autocorrect="off" spellcheck="false"
                :placeholder="(value == '') ? placeholder : ''">
                <option value="">Selecione</option>
                <option :value="item" v-for="(item, index) in select_values" :key="index">{{ item }}</option>
            </select>


            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
                v-if="(force_validation_style === true)">
                <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                    aria-hidden="true">
                    <path fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
                        clip-rule="evenodd" />
                </svg>
            </div>
        </div>
    </div>
</template>

<style scoped>
input:-webkit-autofill+label {
    -webkit-transform: translateY(-14px) scale(0.8);
    transform: translateY(-14px) scale(0.8);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
}

label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* some width */
}
</style>
